import React from 'react';
import MasterCrud from '../masters/MasterCrud';

/**
 * Users admin (super-admin). Manage application users across tenants (Meta Roadways, Ivy's, …):
 * email, role, and company/tenant. Auth (login/password) lives in Firebase — this screen manages
 * the role + tenant mapping. New users must also be registered in Firebase with the same email.
 */
export default function Users() {
  return (
    <MasterCrud
      title="Users"
      endpoint="/api/users"
      columns={[
        { key: 'email', label: 'Email' },
        { key: 'firstName', label: 'First' },
        { key: 'lastName', label: 'Last' },
        { key: 'role', label: 'Role' },
        { key: 'companyName', label: 'Company / Tenant' },
        { key: 'updatedAt', label: 'Last updated' },
      ]}
      formFields={[
        { key: 'firstName', label: 'First Name' },
        { key: 'lastName', label: 'Last Name' },
        { key: 'email', label: 'Email', required: true, helperText: 'Must match the Firebase login email' },
        {
          key: 'role',
          label: 'Role',
          type: 'select',
          required: true,
          options: [
            { value: 'ADMIN', label: 'ADMIN (super-admin)' },
            { value: 'OWNER_OPERATOR', label: 'OWNER_OPERATOR (Meta Roads)' },
            { value: 'IVY_STAFF', label: "IVY_STAFF (Ivy's)" },
            { value: 'IVY_FLATBED', label: "IVY_FLATBED (Ivy's — Flatbed only)" },
            { value: 'LCR_STAFF', label: 'LCR_STAFF' },
            { value: 'DISPATCHER', label: 'DISPATCHER' },
          ],
        },
        {
          key: 'companyId',
          label: 'Company / Tenant',
          type: 'select',
          required: true,
          optionsEndpoint: '/api/master/companies',
          optionValue: 'id',
          optionLabel: 'name',
        },
      ]}
    />
  );
}
